import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "auto" }}>
      <h1>Privacy Policy for Krishidnya</h1>

      <p>
        Krishidnya is an AI-powered smart farming mobile application developed and
        operated by <strong>Krishidnya Agritech</strong>. This Privacy Policy
        explains how Krishidnya collects, uses, and protects user data when you
        use the Krishidnya mobile application and related services.
      </p>

      <h2>Information We Collect</h2>

      <h3>1. Camera Access</h3>
      <p>
        Krishidnya uses camera access to allow users to capture images of crops
        for AI-based disease detection and crop health analysis. Images are used
        only for providing app functionality and are not shared publicly.
      </p>

      <h3>2. Location Information</h3>
      <p>
        We collect approximate location information to provide localized weather
        updates, crop recommendations, and region-specific agricultural insights.
        Location data is not used for tracking users.
      </p>

      <h3>3. Advertising (AdMob)</h3>
      <p>
        Krishidnya uses Google AdMob to display advertisements. AdMob may collect
        device identifiers, cookies, and usage data to show relevant ads in
        accordance with Google’s advertising policies.
      </p>

      <h2>How We Use Your Information</h2>
      <ul>
        <li>To provide AI-based crop disease detection and recommendations</li>
        <li>To offer location-based weather and farming insights</li>
        <li>To improve app performance and user experience</li>
        <li>To display advertisements through Google AdMob</li>
      </ul>

      <h2>Data Sharing</h2>
      <p>
        Krishidnya does not sell or rent personal user data. Data may be shared
        only with trusted third-party services required to operate the app, such
        as Google AdMob and analytics providers, in compliance with their privacy
        policies.
      </p>

      <h2>Data Security</h2>
      <p>
        We take reasonable technical and organizational measures to protect user
        data from unauthorized access, alteration, or disclosure.
      </p>

      <h2>User Choices</h2>
      <p>
        Users can control app permissions such as camera and location access
        through their device settings. Disabling permissions may limit certain
        features of the app.
      </p>

      <h2>Children’s Privacy</h2>
      <p>
        Krishidnya is not intended for children under the age of 13. We do not
        knowingly collect personal data from children.
      </p>

      <h2>Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Changes will be
        posted on this page with an updated revision date.
      </p>

      <h2>Contact Information</h2>
      <p>
        App Name: Krishidnya <br />
        Developer: Krishidnya Agritech <br />
        Email: hello@krishidnya.com <br />
        Website: https://www.krishidnya.com
      </p>

      <p><em>Last updated: December 2025</em></p>
    </div>
  );
};

export default PrivacyPolicy;